module.exports = __webpack_public_path__ + "44c30e4a85d31e2018a79d476d3f0acd.png";